export default from './SurveyPage';



// WEBPACK FOOTER //
// ./src/components/SurveyPage/index.js